import React from 'react';

import Menu, {ComponentProps as MenuProps} from '~/frontend/src/components/base/shared/menu/PropertiesAndReferencesSelectionMenu';

import {__} from '~/shared/src/utilities/messageCatalog';


const defaultProps = {
    buttonClassName     : 'yn-copy-xml-button' as string,
    buttonIconClassName : 'pi pi-copy' as string,
    buttonTooltip       : 'YN.base.common.copyXml' as string,
    menuTitle           : 'YN.base.finder.selectPropertiesAndReferences.copyXML.title' as string,
    menuDescription     : 'YN.base.finder.selectPropertiesAndReferences.copyXML.text' as string
}
type DefaultProps = typeof defaultProps;

type Props = MenuProps;

export type ComponentProps = Partial<DefaultProps> & Omit<Props, 'buttonClassName' | 'buttonIconClassName' | 'buttonTooltip' | 'buttonTooltipOptions' | 'menuTitle' | 'menuDescription'>;
type AllProps = DefaultProps & Props;


const CopyXmlMenu = ( props : AllProps ) => {
    return <Menu
        {...props}
        buttonTooltip={__( props.buttonTooltip )}
        menuTitle={__( props.menuTitle )}
        menuDescription={__( props.menuDescription )}
    />;
}

CopyXmlMenu.defaultProps = defaultProps;

export default CopyXmlMenu;
